module.exports = __webpack_public_path__ + "static/img/Eniksen_Logo_BW_def.d5cb9b54.png";